import types from './types';

const initialState = {
	isFaculty: false,
	loading: true,
	profile: null,
};

export default (state = initialState, action) => {
	switch (action.type) {
		/* Set search term  */
		case types.UPDATE_PROFILE:
			const role = localStorage.getItem('role');
			let isFaculty = false;
			if (role && role === 'faculty') {
				isFaculty = true
			}
			return {
				loading: false,
				isFaculty,
				profile: action.payload
			};
		default:
			return state;
	}
};
